/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { REGEX } from "valuchaincommon/regex";
@Injectable({
  providedIn: "root",
})
export class RegexService {
  constructor() {}
  getOtpRegex() {
    return RegExp(REGEX.exp_OTP.substring(1, REGEX.exp_OTP.length - 1));
  }
  getGSTRegex() {
    return RegExp(REGEX.exp_GSTIN.substring(1, REGEX.exp_GSTIN.length - 1));
  }
  getPANRegex() {
    return RegExp(REGEX.exp_PAN.substring(1, REGEX.exp_PAN.length - 1));
  }
  getEmailRegex() {
    return RegExp(REGEX.exp_mail);
  }
  getPhoneRegex() {
    return RegExp(REGEX.exp_phone.substring(1, REGEX.exp_phone.length - 1));
  }
  getAcctRegex() {
    return RegExp(
      REGEX.exp_accountNumber.substring(1, REGEX.exp_accountNumber.length - 1)
    );
  }
  getIFSCRegex() {
    return RegExp(REGEX.exp_IFSC.substring(1, REGEX.exp_IFSC.length - 1));
  }
  getAadharRegex() {
    return RegExp(REGEX.exp_aadhar.substring(1, REGEX.exp_aadhar.length - 1));
  }
  getEsiRegex() {
    return RegExp(REGEX.exp_esi.substring(1, REGEX.exp_esi.length - 1));
  }
  getPincodeRegex() {
    return RegExp(REGEX.exp_pincode.substring(1, REGEX.exp_pincode.length - 1));
  }
  getJdxAccountNumberRegex() {
    return RegExp(
      REGEX.exp_jdxAccountNumber.substring(
        1,
        REGEX.exp_jdxAccountNumber.length - 1
      )
    );
  }
  getUrlVerifyRegex() {
    return RegExp(REGEX.exp_urlverf);
  }
  getIsoDateRegex() {
    return RegExp(REGEX.exp_isoDate);
  }
  getFloatValueRegex() {
    return RegExp(REGEX.exp_floatValue);
  }
}
